// extracted by mini-css-extract-plugin
export default {"tridi-dot":"styles_tridi-dot__WFRnW","tridi-pin":"styles_tridi-pin__479sy"};